import { handleHttpRequest, http, type HttpResponse } from 'interfaces'
import { type OrgParams } from 'components'
import { type Country } from '../../countriesListService'
export interface BaseUrl {
  id: number
  typeId: number
  descId: number
  value: string
  displayOrder: number
  updatedBy?: string
  lastUpdated: string
}
export interface OrgUrl extends BaseUrl {
  orgId: number
}

export interface OrgUrlResponse {
  urls: OrgUrl[]
  sourceUrls: OrgUrl[]
}

export interface OrganizationBasicInformation extends NewOrganizationInformation {
  id: number
  uniqueId: string
  urls: OrgUrl[]
  lastUpdated: string | undefined
  lastAudited: string | undefined
}

export interface NewOrganizationInformation {
  organizationName: string
  organizationNameLocal: string
  country: Country | null
  parentOrganization: OrgParams | null
  orgTypeId: number | null
}

export interface UpdatedOrgResponse {
  id: number
}

export async function getOrgBasicInfo (orgId: number): Promise<OrganizationBasicInformation> {
  return await http
    .get(`/api/v1/organizations/${orgId}/`, {
    }).then(value => {
      const data: OrganizationBasicInformation = value.data
      data.parentOrganization = (data.parentOrganization != null) ? { ...data.parentOrganization, title: `${data.parentOrganization.id} - ${data.parentOrganization.title}` } : null
      return data
    })
}

export async function updateOrgBasicInfo (orgId: number, payload: any): Promise<HttpResponse<UpdatedOrgResponse>> {
  return await handleHttpRequest(http.patch(`/api/v1/organizations/${orgId}/`, payload))
}

export async function deleteOrg (orgId: number): Promise<HttpResponse<null>> {
  return await handleHttpRequest(http.delete(`/api/v1/organizations/${orgId}/`))
}

export async function getUrlsByOrganization (orgId: number): Promise<OrgUrlResponse> {
  return await http
    .get(`/api/v1/organizations/${orgId}/url/`, {})
    .then(value => value.data)
    .catch(() => { return [] })
}
